// extracted by mini-css-extract-plugin
module.exports = {"Container":"UploadDocuments_Container__zD8P_","form":"UploadDocuments_form__3baiG","Submit":"UploadDocuments_Submit__1NAGn","Error":"UploadDocuments_Error__3Ymbv"};